export default __webpack_public_path__ + "static/media/ic_kcc_96.d4d08218.svg";